import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timezoneDisplay'
})
export class TimezoneDisplayPipe implements PipeTransform {

  transform(displayName: string, showTimeZoneRegion: boolean): string {
    if (showTimeZoneRegion) {
      return displayName;
    }
    
    return this.extractTimezoneOffset(displayName);
  }

  private extractTimezoneOffset(displayName: string): string {
    // Extract text between parentheses: "(UTC-12:00) International Date Line West" -> "UTC-12:00"
    const startIndex = displayName.indexOf('(');
    const endIndex = displayName.indexOf(')');

    if (startIndex >= 0 && endIndex > startIndex) {
      return displayName.substring(startIndex + 1, endIndex);
    }

    // Fallback: return original if parentheses not found
    return displayName;
  }
}